module.exports = __webpack_public_path__ + "static/media/div3.2f2639d7.jpg";